import React from 'react';
import './skeleton.sass';

const Skeleton = ({ children }) => {
  return <div className="skeleton">{children}</div>;
};

export default Skeleton;
